enum DeviceTypes {
  IOS = "IOS",
  ANDROID = "ANDROID",
}

export { DeviceTypes };
